import { getService } from 'data/function';
export class UserContextProcessor {
    static get ContextProcessorService() {
        return getService('ContextProcessorService');
    }
    static get AccountService2() {
        return getService('AccountService2');
    }
    static sendResponse(response, trackingProperties, source) {
        const messageResponse = {
            response,
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
    }
    /**
     * Process command from postMessage event
     * @param payload
     */
    static async process({ message, trackingProperties, source }) {
        try {
            const command = message.content && message.content.command;
            let response;
            switch (command) {
                case 'getCurrentTenant':
                    await UserContextProcessor.ContextProcessorService.waitForInitialization();
                    this.sendResponse(UserContextProcessor.ContextProcessorService.tenant, trackingProperties, source);
                    break;
                case 'setCurrentTenant':
                    response = UserContextProcessor.ContextProcessorService.tenant = message.content.tenant;
                    this.sendResponse(response, trackingProperties, source);
                    window.location.reload();
                    break;
                case 'getCurrentUser':
                    response = await UserContextProcessor.AccountService2.me();
                    this.sendResponse(response, trackingProperties, source);
                    break;
                default:
                    response = 'Command not found';
                    this.sendResponse(response, trackingProperties, source);
            }
            const messageResponse = {
                response,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
